import { useQuery } from '@tanstack/react-query';
import { getSearchFacets } from '../borrowed/catalog-app/typescript/src/app/transport/api';

/**
 * Get the available search facets from catalog
 */
export const useCatalogSearchFacets = () => {
  return useQuery(['searchFacets'], () => getSearchFacets(), {
    refetchOnWindowFocus: false,
    cacheTime: 1200000
  });
};
//# sourceMappingURL=useCatalogSearchFacets.js.map